import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";

const FAQS = [
  {
    q: "Was passiert, wenn es regnet?",
    a: "Kein Problem: Wir verschieben kostenlos auf einen neuen Termin. Oder wir nutzen das Wetter — Regen und Wolken können auf Bildern richtig stark aussehen.",
  },
  {
    q: "Wann bekomme ich meine Bilder?",
    a: "Meist innerhalb von 3 bis 7 Tagen. Bei Hochzeiten bekommst du eine erste Vorschau schon nach 48 Stunden.",
  },
  {
    q: "Wie bekomme ich meine Bilder?",
    a: "Über deine private Online-Galerie mit persönlichem Zugangscode: anschauen, teilen und in voller Qualität herunterladen — alles inklusive.",
  },
  {
    q: "Muss ich posieren können?",
    a: "Überhaupt nicht. Ich führe dich locker durchs Shooting — die besten Bilder entstehen ganz nebenbei, wenn du einfach du selbst bist.",
  },
  {
    q: "Wo findet das Shooting statt?",
    a: "Überall in Ulm, Neu-Ulm, Vöhringen, Günzburg, Bopfingen und Umgebung — draußen, bei dir zu Hause oder an deinem Lieblingsort.",
  },
];

export const Faq = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" data-testid="faq-section" className="border-t border-white/10 bg-ink2">
      <div className="mx-auto grid max-w-[1440px] grid-cols-1 gap-12 px-6 py-28 lg:grid-cols-12 lg:px-12 lg:py-40">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9 }}
          className="lg:col-span-4"
        >
          <p className="mb-4 font-mono text-[11px] uppercase tracking-[0.35em] text-gold">Häufige Fragen</p>
          <h2 className="font-serif text-3xl font-light tracking-tight text-white sm:text-4xl lg:text-5xl">
            Gut zu wissen, <span className="italic text-zinc-400">bevor wir loslegen.</span>
          </h2>
        </motion.div>

        <div className="lg:col-span-8">
          {FAQS.map((f, i) => (
            <motion.div
              key={f.q}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.06 }}
              className="border-b border-white/10 first:border-t"
              data-testid={`faq-item-${i + 1}`}
            >
              <button
                onClick={() => setOpen(open === i ? -1 : i)}
                data-testid={`faq-question-${i + 1}`}
                className="flex w-full items-center justify-between gap-6 py-6 text-left"
              >
                <span className={`font-serif text-xl transition-colors sm:text-2xl ${open === i ? "text-gold" : "text-white"}`}>{f.q}</span>
                <Plus size={18} className={`shrink-0 text-gold transition-transform duration-300 ${open === i ? "rotate-45" : ""}`} />
              </button>
              <AnimatePresence initial={false}>
                {open === i && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                    className="overflow-hidden"
                  >
                    <p className="max-w-2xl pb-6 text-sm leading-relaxed text-zinc-400" data-testid={`faq-answer-${i + 1}`}>
                      {f.a}
                    </p>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
